// extracted by mini-css-extract-plugin
module.exports = {"reportErrorContainer":"report-error_reportErrorContainer__mUUWB"};